import { PhotoIcon, SaveIcon } from '../../../../../../../common/ui/icons';
import { download } from '../../../../../../../common/domain/io-provider';
import { useDecisionTreeStore } from '../dal/decision-tree-store';

const Tree = () => {

    const includeCalculations = useDecisionTreeStore(store => store.includeCalculations);
    const decisionTree = useDecisionTreeStore(store => store.decisionTree);

    const onSaveAsPngClick = async () => {
        const $svg = document.getElementById('decision-tree-svg') as unknown as SVGSVGElement;
        if (!$svg) return;

        await download({
            $svg,
            outfileName: 'decision-tree',
            ext: 'png',
        });
    };

    const onFullScreenClick = async () => {
        const $svg = document.getElementById('decision-tree-svg') as unknown as SVGSVGElement;
        if(!$svg) return;

        await $svg.requestFullscreen();
    };

    return (
        <div className="my-4 text-sm max-w-full mr-auto overflow-auto" dir="ltr">
            {/*<EntropyFormula/>*/ }

            <div className="flex items-center">
                <button
                    onClick={ onSaveAsPngClick }
                    className="flex items-center mr-4"
                    type="button">
                    <SaveIcon color={ '#000' } size={ 20 } classes="mr-2"/>
                    Save as PNG
                </button>

                <button
                    onClick={ onFullScreenClick }
                    className="flex items-center"
                    type="button">
                    <PhotoIcon color={ '#000' } size={ 17 } classes="mr-2"/>
                    FullScreen
                </button>
            </div>

            <div>{ decisionTree?.draw(includeCalculations) }</div>
        </div>
    )
};

export default Tree;